import { makeStyles } from 'tss-react/mui';
import { HISTOWIZ_PRIMARY_COLOR } from 'utilities/colors';

export const useSnackbarActionCloseButtonStyles = makeStyles()(() => ({
  root: {
    cursor: 'pointer',
    color: '#1C1B1FB2',
    width: 32,
    height: 32,
    borderRadius: 4,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '&:hover': {
      backgroundColor: '#2F2E321A',
    },
  },
  icon: {
    fontSize: 16,
  },
}));

export const useSnackbarAction = makeStyles()(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  buttonLink: {
    color: HISTOWIZ_PRIMARY_COLOR,
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '16.41px',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '8px 12px',
    borderRadius: 4,
    '&:hover': {
      backgroundColor: '#EC6A7A1A',
    },
  },
}));
